export default __webpack_public_path__ + "media/components/InstructionButton/images/rule5-a1e89536abfc65856b4f9fe3f51ffe85.png";